import { render } from "./balkenMitBildFolien.vue?vue&type=template&id=1f60baf6"
import script from "./balkenMitBildFolien.vue?vue&type=script&lang=js"
export * from "./balkenMitBildFolien.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__